/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemSpecialityGroupSaveModel } from '../../models/system-speciality-group-save-model';
import { SystemSpecialityGroupViewModel } from '../../models/system-speciality-group-view-model';

export interface ApiAdminSystemSpecialityGroupsPost$Params {
      body?: SystemSpecialityGroupSaveModel
}

export function apiAdminSystemSpecialityGroupsPost(http: HttpClient, rootUrl: string, params?: ApiAdminSystemSpecialityGroupsPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>> {
  const rb = new RequestBuilder(rootUrl, apiAdminSystemSpecialityGroupsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<SystemSpecialityGroupViewModel>;
    })
  );
}

apiAdminSystemSpecialityGroupsPost.PATH = '/api/Admin/system-speciality-groups';
